
    import {useStore} from "@/store";
    import {useRouter} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive} from "vue";

    interface Photo {
        photoIdStr: string;
        smallPhotoUrl: string;
        photoName: string;
    }

    interface State {
        photoList: Array<Photo>;
        slideIndex: number;
        bannerSwiper: object;
        photoLength: number;
    }
    export default defineComponent({
        name: "ensureService",
        setup() {
            let state: State = reactive({
                isNoDefect: false as any,
                point: "N" as any,
                photoList: [],
                slideIndex: 0,
                bannerSwiper: {},
                photoLength: 0
            })
            function urlConversion(path) {
                let reg = /^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/i
                path = path.replace(reg, "https://$2$3$4$5$6");
                return path
            }
            const store = useStore()
            // 获取路由器实例
            const router = useRouter()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {photoList, markPhotoList, paintPhotoList} = data
                state.photoList = photoList
                state.photoLength = photoList.length +
                (markPhotoList ? markPhotoList.length : 0) +
                (paintPhotoList ? paintPhotoList.length : 0)
            })
            return {
                state,
                router,
                urlConversion
            }
        },
        methods: {
            goPhoto(){
                this.router.push({
                    path:'/h5PhotoList',
                    query: {
                        isAll: 'total'
                    }
                })
            },
            goBanner(){
                this.router.push({
                    path:'/h5PhotoList',
                    query: {
                        isAll: 'swiper'
                    }
                })
            }
        }
    })
